(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-size-guide"] && !Shopify.designMode) return;
  try {
    
  // The cm / inch switch only toggles a data attribute on the tables wrapper.
  // Delegated from the document so it survives section re-renders in the editor.
  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.vb-sg__unit-input');
    if (!input) return;

    const tables = input.closest('.vb-sg__tables');
    if (!tables) return;

    tables.dataset.unit = input.classList.contains('vb-sg__unit-input--in') ? 'in' : 'cm';

    // Horizon scrolls inside .page-wrapper, not the document, so clamping
    // window.scrollY would do nothing. Find the real scroll container and pull
    // it back inside its new range - otherwise the shorter inch tables leave a
    // tall blank strip where the taller cm tables used to be.
    requestAnimationFrame(() => {
      void tables.offsetHeight;

      let node = tables.parentElement;
      while (node && node !== document.body) {
        const overflowY = getComputedStyle(node).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) break;
        node = node.parentElement;
      }

      const scroller = node && node !== document.body ? node : document.scrollingElement;
      if (!scroller) return;

      const max = Math.max(scroller.scrollHeight - scroller.clientHeight, 0);
      if (scroller.scrollTop > max) scroller.scrollTop = max;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
